import { Home, Library, Star, Compass, Settings } from 'lucide-react';

export type TabId = 'home' | 'journey' | 'library' | 'favorites' | 'discover' | 'ontology' | 'help' | 'settings';

const TABS: { id: TabId; label: string; Icon: typeof Library }[] = [
  { id: 'home', label: 'Home', Icon: Home },
  { id: 'library', label: 'Library', Icon: Library },
  { id: 'discover', label: 'Discover', Icon: Compass },
  { id: 'favorites', label: 'Favorites', Icon: Star },
];

interface BottomNavProps {
  active: TabId;
  onChange: (tab: TabId) => void;
  unreadChat?: number;
  onSettings?: () => void;
}

export default function BottomNav({ active, onChange, unreadChat = 0, onSettings }: BottomNavProps) {
  // Settings hosts the "Chat with Developer" entry now, so the unread-chat
  // badge rides on the Settings tab.
  const settingsActive = active === 'settings' || active === 'help';
  return (
    <nav className="bottom-nav">
      {TABS.map(({ id, label, Icon }) => (
        <button
          key={id}
          className={`bottom-nav-tab${active === id ? ' bottom-nav-tab--active' : ''}`}
          onClick={() => onChange(id)}
          aria-current={active === id ? 'page' : undefined}
          aria-label={label}
        >
          <Icon size={26} />
        </button>
      ))}

      <button
        className={`bottom-nav-tab bottom-nav-tab--action${settingsActive ? ' bottom-nav-tab--active' : ''}`}
        onClick={onSettings}
        aria-current={settingsActive ? 'page' : undefined}
        aria-label="Settings"
      >
        <span className="bottom-nav-icon-wrap">
          <Settings size={26} />
          {unreadChat > 0 && <span className="fab-badge">{unreadChat}</span>}
        </span>
      </button>
    </nav>
  );
}
